import { render } from "./summary-detail.vue?vue&type=template&id=1e31130f"
import script from "./summary-detail.vue?vue&type=script&lang=js"
export * from "./summary-detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__